module.exports = __webpack_public_path__ + "img/Group 962t3.1b81d7fc.svg";